import { CreditCardIframe } from '@raisenow/epik';
import { Observable } from 'rxjs';

/**
 * Observable to listen for messages from EPIKs
 * Credit Card iframe
 *
 * @param creditCardIframe Instance of the iframe
 * @param topic The topic to listen to
 *
 * @returns
 * An `Observable` that emits all messages for a given `topic` received
 * from the given `creditCardIframe`.
 *
 * @example
 * const ccIframe = await payment.showCreditCardIframe('#id');
 *
 * // to await that the iframe is ready
 * const isReady$ =
 *  fromCreditCardIframeMessage(ccIframe, 'rnw.credit-card.ready')
 *  .pipe(first());
 */
export function fromCreditCardIframeMessage(
  creditCardIframe: CreditCardIframe,
  topic: string,
): Observable<unknown> {
  return new Observable((subscriber) => {
    const onEvent = (value: unknown) => {
      subscriber.next(value);
    };

    creditCardIframe.messenger.on(topic, onEvent);

    return () => {
      creditCardIframe.messenger.off(topic, onEvent);
    };
  });
}
